import React, { useMemo } from 'react';
import { VStack, useTheme } from '@chakra-ui/react';
import { ColorPaletteForm } from './ColorPaletteForm';

export const ColorPalette = () => {
  const { colors } = useTheme();

  const colorsToDisplay = useMemo(() => {
    const AC = ['primary'];
    const c: { variant: string }[] = [];
    Object.keys(colors).forEach((key) => {
      if (AC.includes(key)) {
        c.push({
          variant: key,
          ...colors[key],
        });
      }
    });
    return c;
  }, [colors]);

  return (
    <VStack align="flex-start" spacing={8} w="100%">
      {colorsToDisplay.map((c) => (
        <ColorPaletteForm key={c.variant} item={c} />
      ))}
    </VStack>
  );
};
